module.exports = __webpack_public_path__ + "img/circle-ampersand.18194ed6.svg";